<template>
    <Modal
        v-model="modals"
        scrollable
        title="审核"
        class="audit_box"
        :closable="false"
        width="600"
        @on-visible-change="changeModal">
        <Form
            v-if="modals"
            ref="formItem"
            :model="formData"
            :label-width="100"
            @submit.native.prevent>
            <FormItem label="审核状态：" props="state" label-for="state">
                <RadioGroup class="radio" v-model="formData.apply_status" element-id="apply_status">
                    <Radio :label="20">通过</Radio>
                    <Radio :label="30">拒绝</Radio>
                </RadioGroup>
            </FormItem>
            <FormItem label="驳回原因：" v-if="formData.apply_status == 30">
                <Input type="textarea" :rows="4" v-model="formData.reject_reason" placeholder="" style="width: 100%"/>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="cancel">取消</Button>
            <Button type="primary" @click="ok">提交</Button>
        </div>
    </Modal>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "audit",
        props: {
        },
        data() {
            return {
                modals: false,
                formData: {
                    apply_status: 0
                },
                selectData: [],
            };
        },
        computed: {
        },
        methods: {
            changeModal(status) {
                if (!status) {
                    this.cancel();
                }
            },
            cancel(name) {
                this.modals = false;
            },
            ok() {
                if (!this.formData.apply_status) {
                    return this.$Message.error('请选择审核状态');
                }

                if (this.formData.apply_status == 30 && !this.formData.reject_reason) {
                    return this.$Message.error('请输入驳回原因');
                }
                this.$emit("confirmFormData", this.formData);
            }
        },
    };
</script>

<style scoped>
    .express_temp_id {
        position: relative;
    }

    .express_temp_id button {
        position: absolute;
        top: 50%;
        right: 110px;
        padding: 0;
        border: none;
        background: none;
        transform: translateY(-50%);
        color: #57a3f3;
    }

    .ivu-btn-text:focus {
        box-shadow: none;
    }

    .trips {
        color: #ccc;
    }

    .product-data {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .product-data .image {
        width: 50px !important;
        height: 50px !important;
    }

    .line2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
</style>
